export const formatExpiresCountdown = (totalSeconds: number): string => {
  const safe = Math.max(0, Math.floor(totalSeconds));
  const hours = Math.floor(safe / 3600);
  const minutes = Math.floor((safe % 3600) / 60);
  const seconds = safe % 60;
  return [hours, minutes, seconds].map((n) => String(n).padStart(2, '0')).join(':');
};

export const isValidEmail = (email: string): boolean =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());

/** Display amounts with 4 decimal places (USDT / USD). */
export const formatAmount4 = (value: string | number | null | undefined): string => {
  if (value == null || value === '') return '0.0000';
  const num = Number(value);
  if (!Number.isFinite(num)) return String(value);
  return num.toFixed(4);
};
